module.exports = __webpack_public_path__ + "static/media/ziare.66b6b721.svg";